var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-40e9d7d2-de52-4f52-8c52-ed31d5e6e8b3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 33.74 33.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-cd8254d0-0a06-4065-b9ea-78a3cf2a56d8{fill:none;stroke:url(#uuid-59259518-43c6-4558-bc85-37aae7421c34);stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-59259518-43c6-4558-bc85-37aae7421c34",
    x1: 3.99,
    y1: 9.43,
    x2: 29.75,
    y2: 24.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dfcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#a040ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d640ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-ed797d42-273b-41f6-8887-10cdefde1b04"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-cd8254d0-0a06-4065-b9ea-78a3cf2a56d8",
    d: "m2,16.87h29.74M16.87,2v29.74"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.8c1a9def77176c0a38cc3e7a82472099.svg";
export { ForwardRef as ReactComponent };